







import {
  defineComponent, ref, useFetch,
} from '@nuxtjs/composition-api';
import useRelatedProducts from '~/modules/catalog/product/composables/useRelatedProducts';
import ProductsCarousel from '~/modules/catalog/product/components/ProductsCarousel.vue';
import { usePageStore } from '~/stores/page';

export default defineComponent({
  name: 'RelatedProducts',
  components: {
    ProductsCarousel,
  },
  setup() {
    const { routeData } = usePageStore();
    const {
      search,
      loading,
    } = useRelatedProducts();
    const products = ref([]);

    useFetch(async () => {
      const baseSearchQuery = {
        filter: {
          sku: {
            eq: routeData.sku,
          },
        },
      };

      products.value = await search(baseSearchQuery);
    });

    return {
      products,
      loading,
    };
  },
});
